import React from "react";
import { TrackingCaseDocumentEditModalTemplate } from "themes/application/tracking-case/components";
import { observer } from "mobx-react";
import { TrackingCaseDocumentEditModalStore } from "application/tracking-case/stores";
import { setCurrentView } from "core/utils";

@setCurrentView((rootStore,componentProps) => new TrackingCaseDocumentEditModalStore(rootStore,componentProps), "trackingCaseDocumentEditModalStore")
@observer
class TrackingCaseDocumentEditModal extends React.Component {
    render() {
        return <TrackingCaseDocumentEditModalTemplate {...this.props} />;
    }
}

export default TrackingCaseDocumentEditModal;